import { create } from 'zustand';

interface PriceField {
  originalPrice: number;
  contentType: string;
  contentGenre: string;
  price: number;
  amount?: number;
  dealPrice?: number;
  serviceFee?: number;
  talentManagerCost: number;
  subsidyAmount: number;
  actualGet: number; // 达人实际到手金额
  bonusAmount?: number; // 按时提交奖金金额(会因为逾期等原因清零，多用来判断是否有奖金)
  originalBonusAmount?: number; // 原始按时提交奖金金额(不会因为逾期等原因清零，用在逾期申诉中显示奖金金额)
}

export enum GbPricingSchemaFlag {
  DISPLAY_PRICE_CANNOT_CHANGE = 'display_price_cannot_change',
  NOT_DISPLAY_PRICE_CAN_CHANGE = 'not_display_price_can_change',
  DISPLAY_PRICE_CAN_CHANGE = 'display_price_can_change'
}

export interface ScreeningQuestion {
  question: string;
  answer?: string;
  [key: string]: any;
}

type MultiplePricesStore = {
  gbPricingSchemaFlag: GbPricingSchemaFlag;
  setGbPricingSchemaFlag: (gbPricingSchemaFlag: GbPricingSchemaFlag) => void;
  priceFields: PriceField[];
  setPriceFields: (priceFields: PriceField[]) => void;
  selectedPriceFields: PriceField[];
  setSelectedPriceFields: (selectedPriceFields: PriceField[]) => void;
  creatorLowActualGet: number | null;
  creatorHighActualGet: number | null;
  creatorMaxActualGet: number | null;
  ahaPicksSelectionInitializedKey: string | null;
  clearAllMultiplePricesStore: () => void;
  rateNonNegotiable: boolean;
  setRateNonNegotiable: (rateNonNegotiable: boolean) => void;
  screeningQuestions: ScreeningQuestion[];
  setScreeningQuestions: (screeningQuestions: ScreeningQuestion[]) => void;
  updateScreeningQuestionAnswer: (index: number, answer: string) => void;
  screeningQuestionsError: boolean;
  setScreeningQuestionsError: (screeningQuestionsError: boolean) => void;
  competitivePriceDetail: PriceField | null;
  setCompetitivePriceDetail: (detail: PriceField | null) => void;
  newOrderPrice: number | string;
  setNewOrderPrice: (newOrderPrice: number | string) => void;
};

export const useMultiplePricesStore = create<MultiplePricesStore>()((set) => ({
  gbPricingSchemaFlag: GbPricingSchemaFlag.DISPLAY_PRICE_CANNOT_CHANGE,
  setGbPricingSchemaFlag: (gbPricingSchemaFlag: GbPricingSchemaFlag) =>
    set({ gbPricingSchemaFlag }),
  priceFields: [],
  setPriceFields: (priceFields: PriceField[]) => set({ priceFields }),
  selectedPriceFields: [],
  setSelectedPriceFields: (selectedPriceFields: PriceField[]) =>
    set({ selectedPriceFields }),
  creatorLowActualGet: null,
  creatorHighActualGet: null,
  creatorMaxActualGet: null,
  ahaPicksSelectionInitializedKey: null,
  clearAllMultiplePricesStore: () =>
    set({
      priceFields: [],
      selectedPriceFields: [],
      creatorLowActualGet: null,
      creatorHighActualGet: null,
      creatorMaxActualGet: null,
      ahaPicksSelectionInitializedKey: null,
      screeningQuestions: [],
      screeningQuestionsError: false,
      competitivePriceDetail: null,
      newOrderPrice: ''
    }),
  rateNonNegotiable: false,
  setRateNonNegotiable: (rateNonNegotiable: boolean) =>
    set({ rateNonNegotiable }),
  screeningQuestions: [],
  setScreeningQuestions: (screeningQuestions: ScreeningQuestion[]) =>
    set({ screeningQuestions, screeningQuestionsError: false }),
  updateScreeningQuestionAnswer: (index: number, answer: string) =>
    set((state) => ({
      screeningQuestions: state.screeningQuestions.map((item, i) =>
        i === index ? { ...item, answer } : item
      )
    })),
  screeningQuestionsError: false,
  setScreeningQuestionsError: (screeningQuestionsError: boolean) =>
    set({ screeningQuestionsError }),
  competitivePriceDetail: null, // 输入价格后的 价格详情
  setCompetitivePriceDetail: (competitivePriceDetail: PriceField | null) =>
    set({ competitivePriceDetail }),
  newOrderPrice: '',
  setNewOrderPrice: (newOrderPrice: number | string) => set({ newOrderPrice })
}));
